RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    const PresencePickerItem = Marionette.ItemView.extend({
        template: '#linkedInPresencePickerItemTemplate',
        tagName: 'li',

        triggers: {
            'click a': {
                event: 'companySelected',
                preventDefault: false
            }
        },

        className: function () {
            const me = this;
            return (me.getOption('active') ? 'active' : '');
        },

        templateHelpers: function () {
            const me = this;

            const companies = RivalIQ.state.landscape.get('companies');

            const company = companies.find(function (company) {
                return company.id === me.model.get('companyId');
            });

            return {
                name: (company ? company.get('name') : me.model.get('name'))
            };
        },

        onCompanySelected: function () {
            const me = this;
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ChangedInsightsCompany, {
                channel: CompareData.sourceDetails[CompareData.sources.LINKEDIN].channel,
                company_id: me.model.get('companyId')
            });
        }
    });

    views.PresencePicker = Marionette.CompositeView.mixin({
        template: '#linkedInPresencePickerTemplate',
        childViewContainer: '.dropdown-menu',
        childView: PresencePickerItem,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        events: {
            'click .x-edit': 'onShowEditModal'
        },

        onShowEditModal: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.LinkedInPresenceConfigurationModal({
                accountPresences: me.dashboardModel.accountPresences,
                accountCompanies: me.dashboardModel.accountCompanies,
                model: me.model
            }));
        },

        attachHtml: function (container, childView) {
            const me = this;
            me.$(me.childViewContainer).append(childView.el);
        },

        templateHelpers: function () {
            const me = this;

            let name = null;

            const activePresenceId = me.getProp('presenceId');
            if (activePresenceId) {
                const activePresence = me.collection.get(activePresenceId);
                const companies = RivalIQ.state.landscape.get('companies');

                const company = companies.find(function (company) {
                    return company.id === activePresence.get('companyId');
                });

                name = (company ? company.get('name') : me.model.name);
            }

            return {
                name: name
            };
        },

        showConfigurationModal: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.LinkedInPresenceConfigurationModal({
                accountPresences: me.dashboardModel.accountPresences,
                accountCompanies: me.dashboardModel.accountCompanies
            }));
        },

        childViewOptions: function (model) {
            const me = this;

            return {
                active: me.getProp('presenceId') === model.get('id'),
                presences: me.dashboardModel.presences,
                model: model
            };
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.presences;
        }
    });
}, RivalIQ.data.CompareData);
